<template>
  <TempPageVue>
    <template v-slot:left>
      <div class="col-lg-3">
        <UserFeedInfoVue
          ref="userFeed"
          props_selectItem="MyDynamicPic"
        ></UserFeedInfoVue>
      </div>
    </template>
    <template v-slot:content>
      <div class="col-lg-7 infoEnd">
        <div class="row">
          <div class="col-12">
            <transition name="el-fade-in-linear">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-7">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            :class="{ active: myPhotoDtl.showType == 0 }"
                            href="javascript:void(0);"
                            data-toggle="tab"
                            @click="myPhotoDtl.showType = 0"
                          >
                            {{ $t('Social.MyDynamicPic.photo') }}<span class="count">{{
                              myPhotoDtl.photoCount
                            }}</span></a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            :class="{ active: myPhotoDtl.showType == 1 }"
                            href="javascript:void(0);"
                            data-toggle="tab"
                            @click="myPhotoDtl.showType = 1"
                          >
                            {{ $t('Social.MyDynamicPic.film') }}<span class="count">{{
                              myPhotoDtl.videoCount
                            }}</span></a
                          >
                        </li>
                      </ul>
                    </div>
                    <!-- Search bar -->
                    <div class="col-5">
                      <div class="search2">
                        <el-input
                          :placeholder="$t('Social.MyDynamicPic.SocialPublish')"
                          suffix-icon="fas fa-search"
                          v-model="myPhotoDtl.SGL_Content"
                        ></el-input>
                      </div>
                    </div>
                    <!-- /.Search bar -->
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body">
                  <!-- My Profile -->
                  <div class="my-media section-group">
                    <div class="row">
                      <div class="col-12" v-show="myPhotoDtl.showType == 0">
                        <div class="row">
                          <div
                            class="col-6 col-md-4 col-lg-3"
                            v-for="item in myPhotoDtl.photoList"
                            :key="item.id"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="viewData(item)"
                            >
                              <div class="feedpost-photo-card card">
                                <div class="feedpost-block">
                                  <div class="feedpost-thumbnail">
                                    <div class="feedpost-responsive">
                                      <div class="feedpost-sizer">
                                        <div
                                          class="feedpost-image"
                                          :style="{
                                            backgroundImage:
                                              'url(' +
                                              `${item.sgL_ImageTempURL}` +
                                              ')',
                                          }"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="row my-5" style="flex: 1">
                            <div class="col">
                              <pagination
                                v-show="
                                  myPhotoDtl.photoList != null &&
                                  myPhotoDtl.photoList.length > 0
                                "
                                :currentPage="pageParams.currentPage"
                                :total="pageParams.total"
                                :limit="pageParams.limit"
                                :pageSizes="pageParams.pageSizes"
                                :small="true"
                                :hide-on-single-page="true"
                                @handleCurrentChange="handleCurrentChangevideo"
                                @handleSizeChange="handleSizeChangevideo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-show="myPhotoDtl.showType == 1">
                        <div
                          class="
                            pool-fm
                            pt-1
                            row row-cols-1 row-cols-sm-2 row-cols-md-3
                            g-3
                          "
                        >
                          <singleVideoVue
                            class="pool-cloud fm-set"
                            v-for="item in myPhotoDtl.videoList"
                            :id="item.id"
                            :url="item.fileShareUrl"
                            :key="item.id"
                            :avatar="item.userLogoBig"
                            :authorName="item.sgL_MyVideoName"
                            :displayName="item.sgL_UsersName"
                            :date="item.sgL_PG_CAddTimerI"
                            :lookCount="item.sgL_PG_CTotalView"
                            :title="item.sgL_Title"
                            :likeCount="item.sgL_PG_CTotalLike"
                            :poster="item.sgL_ImageTempURL"
                            :poster2="item.jietuFileUrl"
                            :item="item"
                            @viewData="viewData(item)"
                            @like="$parent.likeFunc(item, item.sgL_IsLike)"
                          >
                            <template v-slot:SpecifyMenu>
                              <moreMenuVue @ck="$parent.copyLink(item.id)">
                                <template v-slot:icon>
                                  <i class="fa fa-clone mr-1"></i>
                                </template>
                                <template v-slot:txt>  {{ $t('Social.MyDynamicPic.clone') }} </template>
                              </moreMenuVue>
                              <moreMenuVue
                                @ck="$parent.changeShow(item)"
                                v-if="!item.sgL_IsShow"
                              >
                                <template v-slot:icon>
                                  <i class="fa fa-rss mr-1"></i>
                                </template>
                                <template v-slot:txt>  {{ $t('Social.MyDynamicPic.open') }} </template>
                              </moreMenuVue>
                              <moreMenuVue
                                @ck="$parent.changeShow(item)"
                                v-else
                              >
                                <template v-slot:icon>
                                  <i class="fa fa-eye-slash mr-1"></i>
                                </template>
                                <template v-slot:txt>  {{ $t('Social.MyDynamicPic.noOpen') }} </template>
                              </moreMenuVue>
                              <moreMenuVue
                                @ck="
                                  $parent.deleteFunc({
                                    id: item.id,
                                  })
                                "
                              >
                                <template v-slot:icon>
                                  <i class="fa fa-trash mr-1"></i>
                                </template>
                                <template v-slot:txt>  {{ $t('Social.MyDynamicPic.del') }} </template>
                              </moreMenuVue>
                            </template>
                          </singleVideoVue>
                        </div>
                        <div class="row">
                          <div class="row my-5" style="flex: 1">
                            <div class="col">
                              <pagination
                                v-if="
                                  myPhotoDtl.videoList != null &&
                                  myPhotoDtl.videoList.length > 0
                                "
                                :currentPage="pageParams2.currentPage"
                                :total="pageParams2.total"
                                :limit="pageParams2.limit"
                                :small="true"
                                :pageSizes="pageParams2.pageSizes"
                                :hide-on-single-page="true"
                                @handleCurrentChange="handleCurrentChangevideo2"
                                @handleSizeChange="handleSizeChangevideo2"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.My Profile -->
                </div>
                <!-- /.card-body -->
              </div>
            </transition>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right>
      <div class="col-lg-2 col">
        <CreateFeedVue
          ref="creFeed"
          @saveFeed="$parent.saveFeed"
          @checkIsCert="$parent.checkIsCert"
        ></CreateFeedVue>
      </div>
    </template>
  </TempPageVue>
</template>

<script>
import pagination from "../common/Page";
import singleVideoVue from "./singleVideo.vue";
import TempPageVue from "./TempPage.vue";
import CreateFeedVue from "./CreateFeed.vue";
import UserFeedInfoVue from "./UserFeedInfo.vue";
import moreMenuVue from "./moreMenu.vue";

export default {
  components: {
    pagination,
    singleVideoVue,
    TempPageVue,
    CreateFeedVue,
    UserFeedInfoVue,
    moreMenuVue,
  },
  data() {
    return {
      myPhotoDtl: {
        SGL_Content: "",
        photoCount: 0,
        videoCount: 0,
        photoList: null,
        videoList: null,
        showType: 0,
      },
      pageParams: {
        currentPage: 1,
        limit: 6,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
      pageParams2: {
        currentPage: 1,
        limit: 6,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
    };
  },
  created() {
    this.loginUser = this.$store.getters.getcustomer;
    this.singleData();
  },
  watch: {
    "myPhotoDtl.SGL_Content": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          //this.getMyPicture(this.myPhotoDtl.showType);
          if (this.myPhotoDtl.showType == 0) {
            this.getMyPicture();
          } else {
            this.getMyVideo();
          }
        }
      },
    },
    "myPhotoDtl.showType": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.myPhotoDtl.SGL_Content = "";
          if (newvalue == 0) {
            this.getMyPicture();
          } else {
            this.getMyVideo();
          }
        }
      },
    },
  },
  methods: {
    pub(isPub) {
      if (isPub) {
      } else {
      }
    },
    singleData() {
      this.getCount();
      let params = this.$route.params;
      if (!this.IsNullOrEmpty(params) && !this.IsNullOrEmpty(params.showType)) {
        this.myPhotoDtl.showType = params.showType;
      } else {
        this.getMyPicture(0);
      }
    },
    viewData(item) {
      //this.$parent.getSingleData(item.id, null, true);
      this.$parent.viewInfo(item);
    },
    getPageData() {
      if (this.myPhotoDtl.showType == 0) {
        this.getMyPicture();
      } else {
        this.getMyVideo();
      }
    },
    getCount() {
      let params = {
        SGL_Type: -1,
        SGL_Content: this.myPhotoDtl.SGL_Content,
        IsLogin: true,
      };
      this.$api.social
        .GetByUserPhotoDtl(params)
        .then((res) => {
          if (res.data.success) {
            this.myPhotoDtl.photoCount = res.data.result.photoCount;
            this.myPhotoDtl.videoCount = res.data.result.moiveCount;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch({});
    },
    getMyPicture() {
      //this.myPhotoDtl.photoList = null;
      let params = {
        SGL_Type: 1,
        IsLogin: true,
        SGL_Content: this.myPhotoDtl.SGL_Content,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.social
        .GetMySocialData(params)
        .then((res) => {
          if (res.data.success) {
            this.myPhotoDtl.photoList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
            this.myPhotoDtl.photoCount = this.pageParams.total;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch({});
    },
    getMyVideo() {
      //this.myPhotoDtl.videoList = null;
      let params = {
        SGL_Type: 0,
        IsLogin: true,
        SGL_Content: this.myPhotoDtl.SGL_Content,
        SkipCount: (this.pageParams2.currentPage - 1) * this.pageParams2.limit,
        MaxResultCount: this.pageParams2.limit,
      };
      this.$api.social
        .GetMySocialData(params)
        .then((res) => {
          if (res.data.success) {
            this.myPhotoDtl.videoList = res.data.result.items;
            this.pageParams2.total = res.data.result.totalCount;
            this.myPhotoDtl.videoCount = this.pageParams2.total;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        })
        .catch({});
    },
    handleCurrentChangevideo(val) {
      this.pageParams.currentPage = val;
      this.getMyPicture();
    },
    handleSizeChangevideo(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getMyPicture();
    },
    handleCurrentChangevideo2(val) {
      this.pageParams2.currentPage = val;
      this.getMyVideo();
    },
    handleSizeChangevideo2(val) {
      this.pageParams2.limit = val;
      this.pageParams2.currentPage = 1;
      this.getMyVideo();
    },
  },
};
</script>

<style scoped>
.search2 >>> input {
  width: 100%;
  border-radius: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/MyDynamicPic.vue